import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './EmailPage.css';

const EmailPage = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const [loading, setLoading] = useState(false);

  const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const envApiUrl = process.env.REACT_APP_API_URL?.trim();
  const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/leads/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
      });
      if (response.ok) {
        setSubmitted(true);
      } else {
        alert(t('email_page.fail_msg'));
      }
    } catch (error) {
      alert(t('email_page.error_msg'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="email-page">
      <Header />
      
      <main className="email-main">
        <div className="container">
          <div className="email-container">
            <div className="email-header">
              <h1>{t('email_page.title')}</h1>
              <p>{t('email_page.subtitle')}</p>
            </div>

            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h2>{t('email_page.success_title')}</h2>
                <p>{t('email_page.success_desc')}</p>
                <button className="btn-back-home" onClick={() => window.location.href = '/'}>{t('email_page.btn_back_home')}</button>
              </div>
            ) : (
              <form className="email-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>{t('email_page.name_label')}</label>
                  <input 
                    type="text" 
                    placeholder={t('email_page.name_ph')} 
                    required 
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                  />
                </div>
                
                <div className="form-group">
                  <label>{t('email_page.email_label')}</label>
                  <input 
                    type="email" 
                    placeholder={t('email_page.email_ph')} 
                    required 
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                  />
                </div>

                <div className="form-group">
                  <label>{t('email_page.subject_label')}</label>
                  <input 
                    type="text" 
                    placeholder={t('email_page.subject_ph')} 
                    required 
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                  />
                </div>

                <div className="form-group">
                  <label>{t('email_page.message_label')}</label>
                  <textarea 
                    rows="6" 
                    placeholder={t('email_page.message_ph')} 
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                  ></textarea>
                </div>

                <button type="submit" className="btn-submit-email" disabled={loading}>
                  {loading ? t('email_page.btn_sending') : t('email_page.btn_send')}
                </button>
              </form>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default EmailPage;


